import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import user from './user'
import languages from './languages'
import modules from '../../config/modules'

const globalReducers = {
  routing: routerReducer,
  user,
  languages
}

// add reducers from modules
const allReducers = modules.reduce((reducers, module) => {
  return { ...reducers, ...module.reducers }
}, globalReducers)

export default combineReducers(allReducers)



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js